/**
 * Build /leads URLs with filters matching management report drill-downs.
 */

function appendPeriodDates(params, from, to, { acquired = false, won = false, demo = false } = {}) {
  if (!from || !to) return;
  if (acquired) {
    params.set('lead_acquired_at_from', from);
    params.set('lead_acquired_at_to', to);
  }
  if (won) {
    params.set('won_at_from', from);
    params.set('won_at_to', to);
  }
  if (demo) {
    params.set('demo_from', from);
    params.set('demo_to', to);
  }
}

function withDimension(params, dimension = {}) {
  if (dimension.sourceGroup) params.set('source_group', dimension.sourceGroup);
  if (dimension.country) params.set('country', dimension.country);
  if (dimension.assignedTo === null) {
    params.set('assigned_to_list', 'unassigned');
  } else if (dimension.assignedTo) {
    params.set('assigned_to_list', dimension.assignedTo);
  }
  if (dimension.teacherId) params.set('teacher_id', dimension.teacherId);
  if (dimension.sessionType) params.set('session_type', dimension.sessionType);
}

/**
 * Cohort leads acquired in period (includes enrolled) — matches report "X Leads".
 */
export function leadCohortLeadsUrl(period, dimension = {}) {
  const params = new URLSearchParams();
  params.set('status', 'all');
  appendPeriodDates(params, period?.from, period?.to, { acquired: true });
  withDimension(params, dimension);
  return `/leads?${params.toString()}`;
}

/**
 * Cohort enrollments — acquired in period and won in period.
 */
export function leadCohortEnrolledUrl(period, dimension = {}) {
  const params = new URLSearchParams();
  params.set('status', 'won');
  appendPeriodDates(params, period?.from, period?.to, { acquired: true, won: true });
  withDimension(params, dimension);
  return `/leads?${params.toString()}`;
}

/**
 * All wins in period for the dimension (may include older leads).
 */
export function leadActivityWinsUrl(period, dimension = {}) {
  const params = new URLSearchParams();
  params.set('status', 'won');
  appendPeriodDates(params, period?.from, period?.to, { won: true });
  withDimension(params, dimension);
  return `/leads?${params.toString()}`;
}

/**
 * Period leads that attended a demo or trial session of the given type.
 */
export function leadSessionTypeUrl(period, dimension = {}, sessionType) {
  const params = new URLSearchParams();
  params.set('status', 'all');
  params.set('session_type', sessionType);
  params.set('attended_only', '1');
  appendPeriodDates(params, period?.from, period?.to, { acquired: true });
  withDimension(params, { ...dimension, sessionType });
  return `/leads?${params.toString()}`;
}

export function leadSessionTypeEnrolledUrl(period, dimension = {}, sessionType) {
  const params = new URLSearchParams();
  params.set('status', 'won');
  params.set('session_type', sessionType);
  params.set('attended_only', '1');
  appendPeriodDates(params, period?.from, period?.to, { acquired: true, won: true });
  withDimension(params, { ...dimension, sessionType });
  return `/leads?${params.toString()}`;
}

/** Trainer: attendees of completed demos in period. */
export function trainerAttendedUrl(period, teacherId, sessionType) {
  const params = new URLSearchParams();
  params.set('status', 'all');
  params.set('teacher_id', teacherId);
  params.set('attended_only', '1');
  appendPeriodDates(params, period?.from, period?.to, { demo: true });
  if (sessionType) params.set('session_type', sessionType);
  return `/leads?${params.toString()}`;
}

/** Trainer: enrolled among attendees. */
export function trainerEnrolledUrl(period, teacherId, sessionType) {
  const params = new URLSearchParams();
  params.set('status', 'won');
  params.set('teacher_id', teacherId);
  params.set('attended_only', '1');
  appendPeriodDates(params, period?.from, period?.to, { demo: true });
  if (sessionType) params.set('session_type', sessionType);
  return `/leads?${params.toString()}`;
}

export function trainerClosedUrl(period, teacherId) {
  const params = new URLSearchParams();
  params.set('status', 'won');
  params.set('teacher_id', teacherId);
  params.set('attended_only', '1');
  appendPeriodDates(params, period?.from, period?.to, { demo: true, won: true });
  return `/leads?${params.toString()}`;
}

export function dimensionFromSourceRow(row) {
  return { sourceGroup: row.sourceGroup };
}

export function dimensionFromCountryRow(row) {
  return { country: row.country };
}

export function dimensionFromSalesRow(row) {
  return { assignedTo: row.userId ?? null };
}
